import React from 'react';

const JS_RegExp_Classes = () => {
  return (
    <div >
      <h1>JS_RegExp_Classes</h1>
      <p>Placeholder component for: "JS RegExp Classes"</p>
    </div>
  );
};

export default JS_RegExp_Classes;
